export const popover = {
  MuiPopover: {
    styleOverrides: {
      paper: {
        width: 'inherit' || '100%'
      },
    },
  },
};
